import shortid from 'shortid';
import CriteriaCondition from './spec/criteria-condition';

/** @module ActiveFilter */

/**
 * Structure used to define a filter that is actively selected as a criteria component.
 * Contains the filter definition and the criteria condition currently displayed.
 */
export default class ActiveFilter {
    filter = null;

    condition = null;

    isActivated = false;

    uid = null;

    /**
     * Initialize an active filter with a definition and a criteria condition.
     * @param {FilterDefinition} filter
     * @param {CriteriaCondition|FilterCondition} condition
     * @param {boolean} isActivated
     * @param {String} uid
     */
    constructor({
        filter,
        condition = new CriteriaCondition(),
        isActivated = false,
        uid = shortid.generate(),
    }) {
        this.isActivated = isActivated;
        this.filter = {...filter};
        this.condition = condition;
        this.uid = uid;
    }
}
